import React from 'react';
import styled from 'styled-components';
import { up } from 'styled-breakpoints';
import { getSignUpUrlWithSession } from '../../lib/cognito';

interface ConversionBannerLinkProps {
  isFixedMatches: boolean;
  message: string;
  onClick?: () => void;
}

interface ConversionBannerLinkStyleProps {
  isFixedMatches: boolean;
}

const ConversionBannerLinkContainer = styled.a<ConversionBannerLinkStyleProps>`
  text-decoration: none;
  transition: color 0.15s ease-in;
  outline: 0;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  border-radius: 0.25rem;
  line-height: 1;
  padding: 0.25rem 0.5rem 0.5rem 0.5rem;
  background-color: ${({ theme }): string => theme.colors.red};
  font-family: ${({ theme }): string => theme.fonts.futuraHeavy};
  font-size: 1rem;
  color: ${({ theme }): string => theme.colors.white};
  white-space: nowrap;

  ${up('tablet-landscape')} {
    padding: 0.5rem 1rem 1rem 1rem;
  }

  ${({ isFixedMatches }): string =>
    isFixedMatches ? 'padding-top: 0.5rem; font-size: 0.75rem;' : ''}

  &:focus {
    outline: -webkit-focus-ring-color auto 1px;
  }

  span {
    display: inline-block;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    margin-top: ${({ isFixedMatches }): string => (isFixedMatches ? '0' : '0.5rem')};
  }
`;

const ConversionBannerLink: React.FC<ConversionBannerLinkProps> = ({
  isFixedMatches,
  message,
  onClick,
}) => {
  const signUpUrl = getSignUpUrlWithSession();
  return (
    <ConversionBannerLinkContainer
      href={signUpUrl}
      isFixedMatches={isFixedMatches}
      onClick={onClick}
    >
      <span>{message}</span>
    </ConversionBannerLinkContainer>
  );
};

export default ConversionBannerLink;
